import React, { useEffect, useState } from "react";
import { Layout, Menu, Drawer, Space, Badge, Flex, Image, Grid } from "antd";
import {
  SearchOutlined,
  ShoppingCartOutlined,
  UserOutlined,
  MenuOutlined,
  CloseOutlined,
} from "@ant-design/icons";
import { useNavigate, useLocation } from "react-router-dom";

// import HeaderLogo from "../../../Images/Header/header-logo.png";
import HeaderLogo from "../../../Images/Header/no-bg-header-logo.png";

import CartDrawer from "../../Common/cartDrawer";

const { Header } = Layout;
const { useBreakpoint } = Grid;

const AppHeader = () => {
  const [drawerOpen, setDrawerOpen] = useState(false);
  const screens = useBreakpoint();
  const navigate = useNavigate();
  const location = useLocation();

  const menuItems = [
    { key: "/promotions", label: "Promotions" },
    { key: "/products", label: "Products" },
    { key: "/catalogues", label: "Catalogue" },
    { key: "/company", label: "Company" },
    { key: "/locate-us", label: "Locate Us" },
    { key: "/contact-us", label: "Contact Us" },
    { key: "/corporate-website", label: "Corporate" },
  ];

  const handleNavigate = (key) => {
    if (key === "/promotions") {
      if (location.pathname === "/") {
        const element = document.getElementById("promotion-section");

        if (element) {
          element.scrollIntoView({ behavior: "smooth" });
        }
      } else navigate("/", { state: { scrollTo: "promotion-section" } });
    } else if (key === "/corporate-website") {
      window.location.href = "https://teamstarberhad.com/";
    } else navigate(key);

    setDrawerOpen(false);
  };

  const [cartOpen, setCartOpen] = useState(false);
  const [badgeCount, setBadgeCount] = useState(0);

  useEffect(() => {
    const updateCount = () => {
      const cartItems = JSON.parse(localStorage.getItem("cartItems")) || [];
      setBadgeCount(cartItems.length);
    };

    updateCount();

    window.addEventListener("storage", updateCount);
    window.addEventListener("cartUpdated", updateCount);

    return () => {
      window.removeEventListener("storage", updateCount);
      window.removeEventListener("cartUpdated", updateCount);
    };
  }, [drawerOpen, cartOpen]);

  return (
    <Header
      style={{
        background: "#FFDC00",
        padding: "0 24px",
        height: 64,
        position: "sticky",
        top: 0,
        zIndex: 100,
      }}
    >
      <Flex justify="space-between" align="center" style={{ height: "100%" }}>
        {/* Left: Logo */}
        <div
          onClick={() => navigate("/")}
          style={{ cursor: "pointer", marginLeft: screens.md ? "5%" : 0 }}
        >
          <Image
            src={HeaderLogo}
            preview={false}
            height={25}
            className="header-logo"
          />
        </div>

        {/* Right: Only burger icon (for mobile) */}
        {!screens.xl && (
          <MenuOutlined
            style={{ fontSize: 22, color: "#4B5563", cursor: "pointer" }}
            onClick={() => {
              setDrawerOpen(true);
              setCartOpen(false);
            }}
          />
        )}

        {/* Desktop menu — hidden on mobile */}
        {screens.xl && (
          <>
            <Menu
              mode="horizontal"
              selectedKeys={[location.pathname]}
              items={menuItems}
              onClick={(e) => handleNavigate(e.key)}
              style={{
                background: "transparent",
                lineHeight: "64px",
                flex: 1,
                minWidth: 0,
                marginLeft: "1%",
                fontWeight: "600",
              }}
            />

            <Space size="large" style={{ padding: "16px", marginRight: "5%" }}>
              {/* <SearchOutlined
                className="drawer-icon"
                style={{ fontSize: 20, cursor: "pointer", color: "#4B5563" }}
              /> */}

              <Badge
                count={badgeCount}
                size="small"
                style={{
                  backgroundColor: "black",
                  borderColor: "black",
                  color: "white",
                  fontSize: 8,
                }}
              >
                <Flex
                  vertical
                  onClick={() => setCartOpen(true)}
                  className="drawer-icon"
                >
                  <ShoppingCartOutlined
                    style={{
                      fontSize: 20,
                      cursor: "pointer",
                      color: "#4B5563",
                      fontWeight: "600",
                      marginLeft: 10,
                    }}
                  />

                  <b
                    style={{
                      cursor: "pointer",
                      height: 16,
                      marginLeft: 8,
                      fontSize: 12,
                      color: "#4B5563",
                    }}
                  >
                    Cart
                  </b>
                </Flex>
              </Badge>

              <Badge>
                <Flex
                  vertical
                  justify="center"
                  align="center"
                  onClick={() => handleNavigate("/profile")}
                  className="drawer-icon"
                >
                  <UserOutlined
                    style={{
                      fontSize: 20,
                      cursor: "pointer",
                      color: "#4B5563",
                      fontWeight: "600",
                    }}
                  />

                  <span
                    style={{
                      cursor: "pointer",
                      height: 16,
                      fontSize: 12,
                      color: "#4B5563",
                    }}
                  >
                    <b>Profile</b>
                  </span>
                </Flex>
              </Badge>
            </Space>
          </>
        )}
      </Flex>

      {/* Drawer for mobile — navigation + icons */}
      <Drawer
        zIndex={998}
        placement="right"
        onClose={() => setDrawerOpen(false)}
        open={drawerOpen}
        closable={false}
        width={260}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            padding: "0 16px",
          }}
        >
          <CloseOutlined
            onClick={() => setDrawerOpen(false)}
            className="drawer-icon"
          />
        </div>

        <Menu
          mode="vertical"
          selectedKeys={[location.pathname]}
          items={menuItems}
          onClick={(e) => handleNavigate(e.key)}
        />

        <Space size="large" style={{ padding: "16px" }}>
          <SearchOutlined
            className="drawer-icon"
            style={{ fontSize: 20, cursor: "pointer", color: "#4B5563" }}
          />

          <Badge
            count={badgeCount}
            size="small"
            style={{
              backgroundColor: "black",
              borderColor: "black",
              color: "white",
              fontSize: 10,
            }}
          >
            <ShoppingCartOutlined
              className="drawer-icon"
              style={{ fontSize: 20, cursor: "pointer", color: "#4B5563" }}
              onClick={() => {
                setDrawerOpen(false);
                setCartOpen(true);
              }}
            />
          </Badge>

          <UserOutlined
            className="drawer-icon"
            style={{ fontSize: 20, cursor: "pointer", color: "#4B5563" }}
            onClick={() => handleNavigate("/profile")}
          />
        </Space>
      </Drawer>

      <CartDrawer
        open={cartOpen}
        onClose={() => setCartOpen(false)}
        setOpen={setCartOpen}
      />
    </Header>
  );
};

export default AppHeader;
